<template>

    <v-dialog
            v-model="value"
            max-width="350"

    >
        <v-card>
            <v-card-title class="headline"><span v-html="$t('unauthorizedSubscriptionDialog.title')"></span>
              </v-card-title>

            <v-card-text>
              <span v-html="$t('unauthorizedSubscriptionDialog.content')"></span>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>


                <v-btn
                        color="red darken-1"
                        text
                        @click="close"
                >
                  <span v-html="$t('unauthorizedSubscriptionDialog.close')"></span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<style>


</style>

<script>

    export default {
        name: 'Modal_AccountPayment',
        props: ['value'],
        data: () => ({

        }),
      methods: {
          close(){
              this.$emit('input', false);
          }
      }



    };
</script>
